<div class="paginationFooter col-md-12 " *ngIf="pages ">

    <div *ngIf="pages" class="pagination-right border border-secondary-subtle  ">
      <nav *ngIf="pages.length > 1" aria-label="Page navigation example ">
    
        <ul class="pagination justify-content-end ">
          <li class="page-item d-flex align-items-center" [class.disabled]="currentPage === 1" aria-disabled="currentPage === 1">
            <a class="page-link cursor d-flex align-items-center" (click)="getPages(currentPage-1)">
              <img class="pagi-icon-left me-2"alt="Previous">
              <span class="fw-bold">Previous</span>
             
            </a>
            <div class="vl" style="margin-left: 10px; margin-right: 0px;"></div>
          </li>

         
          <li *ngFor="let page of visiblePages" [ngClass]="getPageClasses(page)">
            <a class="page-link cursor" (click)="page !== '...' && getPages(page)">
                {{page}}
            </a>
        </li>
        
      
         
         
          <li class="page-item d-flex align-items-center" [class.disabled]="currentPage === pages.length ? true : false" aria-disabled="currentPage === pages.length ? true : false" >
            <div class="vl" style="margin-right: 10px;"></div>
            <a class="page-link cursor d-flex align-items-center" (click)="getPages(currentPage+1)">
              
              <span class="me-2  p-0 fw-bold">Next</span>
             
              <img class="pagi-icon-right " >
            </a>
            
          </li>
        </ul>
      </nav>
    </div>

</div>